<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/AdminReport/MasterShopByBrand'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div
                class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"
                v-show="this.$root.canShow(['super_admin', 'ADMIN_PM'])"
              >
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'reAgentCodes'"
                        :name="'reAgentCodes'"
                        :select2-options="reAgentCodesOptions"
                        v-model="reAgentCodes"
                        ref="reAgentCodesSelect2"
                        multiple
                    ></select2> -->
                  <treeselect
                    v-model="reAgentCodes"
                    :multiple="true"
                    :options="reAgentCodesOptions"
                    v-on:open="LoadreAgentCodesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reDepartments'"
                    :name="'reDepartments'"
                    :select2-options="reDepartmentsOptions"
                    multiple
                    v-model="reDepartments"
                  ></select2> -->
                  <treeselect
                    v-model="reDepartments"
                    :multiple="true"
                    :options="reDepartmentsOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reShopTypeId'"
                    :name="'reShopTypeId'"
                    :select2-options="reShopTypeIdOptions"
                    v-model="reShopTypeId"
                    ref="reShopTypeIdSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reShopTypeId"
                    :multiple="true"
                    :options="reShopTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เดือน:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reMonth'"
                    :name="'reMonth'"
                    :select2-options="reMonthOptions"
                    v-model="reMonth"
                    ref="reMonthSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ปี :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reYear'"
                    :name="'reYear'"
                    :select2-options="reYearOptions"
                    v-model="reYear"
                    ref="reYear"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะร้านค้า:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reShopStatus'"
                    :name="'reShopStatus'"
                    :select2-options="reShopStatusOptions"
                    v-model="reShopStatus"
                    ref="reShopStatusSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <select2
                    id="reProductBrandId"
                    name="reProductBrandId"
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :select2-options="reProductBrandIdOptions"
                    v-model="reProductBrandId"
                    ref="reProductBrandIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reProvinceId'"
                    :name="'reProvinceId'"
                    :select2-options="reProvinceIdOptions"
                    v-model="reProvinceId"
                    ref="reProvinceIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>อำเภอ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAmpherId'"
                    :name="'reAmpherId'"
                    :select2-options="reAmpherIdOptions"
                    v-model="reAmpherId"
                    ref="reAmpherIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="reIsTransaction"
                        name="reIsTransaction"
                        v-model="reIsTransaction"
                        type="checkbox"
                        class="form-check-input"
                      />
                      สถานะปัจจุบัน
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group ">
                  <label class="label">ข้อมูลระหว่างวันที่(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reStartDate"
                      name="reStartDate"
                      ref="reStartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ข้อมูลระหว่างวันที่(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reEndDate"
                      name="reEndDate"
                      ref="reEndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportMasterShop"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="MasterShopTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="31">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th class="all text-center">เขตการขาย</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">ประเภทร้านค้า</th>
                    <th class="all text-center">ที่อยู่</th>
                    <th class="all text-center">ตำบล</th>
                    <th class="all text-center">อำเภอ</th>
                    <th class="all text-center">จังหวัด</th>
                    <th class="all text-center">รหัสไปรษณีย์</th>
                    <th class="all text-center">Module</th>
                    <th class="all text-center">วัน เดือน ปี</th>
                    <th class="all text-center">วัน</th>
                    <th class="all text-center">เดือน</th>
                    <th class="all text-center">ปี</th>
                    <th class="all text-center">Singha</th>
                    <th class="all text-center">Leo</th>
                    <th class="all text-center">Asahi</th>
                    <th class="all text-center">Carlsberg</th>
                    <th class="all text-center">Kopper</th>
                    <th class="all text-center">Kronenbourg</th>
                    <th class="all text-center">Snowy</th>
                    <th class="all text-center">ANDAMAN</th>
                    <th class="all text-center">BUSSABA</th>
                    <th class="all text-center">DH-Est.33</th>
                    <th class="all text-center">Singha Light</th>
                    <th class="all text-center">U Korn Beer</th>
                    <th class="all text-center">CHALAWAN PALE ALE</th>
                    <th class="all text-center">CHATRI IPA</th>
                    <th class="all text-center">HOF</th>
                    <th class="all text-center">Other</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      reDepartments: [],
      reAgentCodes: [],
      reShopTypeId: [],
      reMonth: null,
      reYear: null,
      reShopStatus: null,
      reProductBrandId: null,
      reProvinceId: null,
      reAmpherId: null,
      brandHeaders: [],
      reDepartmentsOptions: [],
      reIsTransaction: true,
      reStartDate: null,
      reEndDate: null,
      // reDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAgentCodesOptions: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url:
      //       "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reShopTypeIdOptions: [],
      // reShopTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ShopType/Select2SearchShopType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reMonthOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "1", text: "January", data: null },
          { id: "2", text: "February", data: null },
          { id: "3", text: "March", data: null },
          { id: "4", text: "April", data: null },
          { id: "5", text: "May", data: null },
          { id: "6", text: "June", data: null },
          { id: "7", text: "July", data: null },
          { id: "8", text: "August", data: null },
          { id: "9", text: "September", data: null },
          { id: "10", text: "October", data: null },
          { id: "11", text: "November", data: null },
          { id: "12", text: "December", data: null },
        ],
      },
      reYearOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          {
            id: new Date().getFullYear(),
            text: new Date().getFullYear(),
            data: null,
          },
          {
            id: new Date().getFullYear() - 1,
            text: new Date().getFullYear() - 1,
            data: null,
          },
          {
            id: new Date().getFullYear() - 2,
            text: new Date().getFullYear() - 2,
            data: null,
          },
          {
            id: new Date().getFullYear() - 3,
            text: new Date().getFullYear() - 3,
            data: null,
          },
          {
            id: new Date().getFullYear() - 4,
            text: new Date().getFullYear() - 4,
            data: null,
          },
          // {
          //   id: new Date().getFullYear() + 543,
          //   text: new Date().getFullYear() + 543,
          //   data: null,
          // },
          // {
          //   id: new Date().getFullYear() + 542,
          //   text: new Date().getFullYear() + 542,
          //   data: null,
          // },
          // {
          //   id: new Date().getFullYear() + 541,
          //   text: new Date().getFullYear() + 541,
          //   data: null,
          // },
          // {
          //   id: new Date().getFullYear() + 540,
          //   text: new Date().getFullYear() + 540,
          //   data: null,
          // },
          // {
          //   id: new Date().getFullYear() + 539,
          //   text: new Date().getFullYear() + 539,
          //   data: null,
          // },
        ],
      },
      reShopStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ร้านเปิด", data: null },
          { id: "true", text: "ร้านปิด", data: null },
        ],
      },
      reProductBrandIdOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "Singha", text: "Singha", data: null },
          { id: "Leo", text: "Leo", data: null },
          { id: "Asahi", text: "Asahi", data: null },
          { id: "Carlsberg", text: "Carlsberg", data: null },
          { id: "Kopper", text: "Kopper", data: null },
          { id: "Kronenbourg", text: "Kronenbourg", data: null },
          { id: "Snowy", text: "Snowy", data: null },
          { id: "ANDAMAN", text: "ANDAMAN", data: null },
          { id: "BUSSABA", text: "BUSSABA", data: null },
          { id: "DH", text: "D&H-Est.33", data: null },
          { id: "SinghaLight", text: "Singha Light", data: null },
          { id: "UKorn", text: "U Korn Beer", data: null },
          { id: "CHALAWAN", text: "CHALAWAN PALE ALE", data: null },
          { id: "CHATRI", text: "CHATRI IPA", data: null },
          { id: "HOF", text: "HOF", data: null },
          { id: "Other", text: "Other", data: null },
        ],
      },
      reProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.reProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reDepartments = [];
      self.reAgentCodes = [];
      self.reShopTypeId = [];
      (self.reMonth = null), (self.reYear = null);
      self.reShopStatus = null;
      self.reProductBrandId = null;
      self.reAmpherId = null;
      self.reProvinceId = null;
      self.reIsTransaction = true;
      self.reStartDate = null;
      self.reEndDate = null;

      $("#reDepartments")
        .val("")
        .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

      $("#reMonth")
        .val("")
        .trigger("change");

      $("#reYear")
        .val("")
        .trigger("change");

      $("#reShopStatus")
        .val(false+"")
        .trigger("change");

      $("#reProductBrandId")
        .val("")
        .trigger("change");

      $("#reProvinceId")
        .val("")
        .trigger("change");

      $("#reAmpherId")
        .val("")
        .trigger("change");

      $("#reStartDate")
        .val("")
        .trigger("change");

      $("#reEndDate")
        .val("")
        .trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function(e, innerText = null) {
      let self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#MasterShopTable").DataTable();
      table.draw();
    },
    exportMasterShop: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportMasterShopByBrand",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reAgentCodes,
          Department: self.reDepartments,
          ProductBrand: self.reProductBrandId,
          ShopType: self.reShopTypeId,
          Month: self.reMonth,
          Year: self.reYear,
          InActiveStatus: self.reShopStatus,
          ProvinceId: self.reProvinceId,
          AmperId: self.reAmpherId,
          IsTransaction: !self.reIsTransaction,
          StartDate:
            self.reStartDate != null
              ? self.reStartDate.format("DD/MM/YYYY")
              : self.reStartDate,
          EndDate:
            self.reEndDate != null
              ? self.reEndDate.format("DD/MM/YYYY")
              : self.reEndDate,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreAgentCodesOptions: function(e) {
      var self = this;
      self.reAgentCodesOptions = [{ id : "", label : "Loading...", isDisabled: true}]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      axios
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            province_id: [],
            department: self.reDepartments,
            AgentCodes: [],
            all: true,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            self.reAgentCodesOptions = [];
            var data = response.data.results;
            data.forEach((element) => {
              self.reAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreDepartmentsOptions: function(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.reDepartmentsOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reDepartmentsOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    self.LoadreAgentCodesOptions();
    self.LoadreDepartmentsOptions();
    self.LoadreShopTypeIdOptions();

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
    $("#reShopStatus")
        .val(false+"")
        .trigger("change");
        
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#MasterShopTable");
    table.DataTable({
      autoWidth: true,
      scrollY: "100%",
      scrollX: true,
      responsive: true,
      processing: true,
      serverSide: true,
      searchDelay: 500,

      ajax: {
        url: "/Api/Report/MasterShopByBrand",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        beforeSend: function(request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + self.$root.user.access_token
          );
        },
        data: function(d) {
          let jsonSearch = {
            AgentCode: self.reAgentCodes,
            Department: self.reDepartments,
            ProductBrand: self.reProductBrandId,
            ShopType: self.reShopTypeId,
            Month: self.reMonth,
            Year: self.reYear,
            InActiveStatus: self.reShopStatus,
            ProvinceId: self.reProvinceId,
            AmperId: self.reAmpherId,
            IsInitial: self.reAaIsInitial,
            IsTransaction: !self.reIsTransaction,
            StartDate:
              self.reStartDate != null
                ? self.reStartDate.format("DD/MM/YYYY")
                : self.reStartDate,
            EndDate:
              self.reEndDate != null
                ? self.reEndDate.format("DD/MM/YYYY")
                : self.reEndDate,
          };
          return JSON.stringify($.extend(d, jsonSearch));
        },
      },
      // DOM Layout settings
      dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

      lengthMenu: [30, 50, 100],

      pageLength: 30,

      language: {
        lengthMenu: "Display _MENU_",
      },
      // Order settings
      order: [[12, "desc"]],
      columns: [
        { data: "agentCode", className: "text-center" },
        { data: "agentName", className: "text-center" },
        { data: "department", className: "text-center" },
        { data: "name1", className: "text-center" },
        { data: "name2", className: "text-center" },
        { data: "channel", className: "text-center" },
        { data: "address", className: "text-center" },
        { data: "tambon", className: "text-center" },
        { data: "amper", className: "text-center" },
        { data: "province", className: "text-center" },
        { data: "zipCode", className: "text-center" },
        { data: "module", className: "text-center" },
        {
          data: "createdDate",
          className: "text-center",
          render: function(data, type, full, meta) {
            return full.createdDateString;
          },
        },
        { data: "day", className: "text-center" },
        { data: "month", className: "text-center" },
        { data: "year", className: "text-center" },
        { data: "singha", className: "text-center" },
        { data: "leo", className: "text-center" },
        { data: "asahi", className: "text-center" },
        { data: "carlsberg", className: "text-center" },
        { data: "kopper", className: "text-center" },
        { data: "kronenbourg", className: "text-center" },
        { data: "snowy", className: "text-center" },
        { data: "andaman", className: "text-center" },
        { data: "bussaba", className: "text-center" },
        { data: "dh", className: "text-center" },
        { data: "singhaLight", className: "text-center" },
        { data: "ukorn", className: "text-center" },
        { data: "chalawan", className: "text-center" },
        { data: "chatri", className: "text-center" },
        { data: "hof", className: "text-center" },
        { data: "other", className: "text-center" },
      ],
      columnDefs: [
        {
          targets: [7, 8, 9, 10, 13, 14, 15] /* column index */,
          orderable: false /* true or false */,
        },
      ],
      drawCallback: function(settings) {
        self.reAaIsInitial = false;
        self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
      },
    })
    .on("error.dt", function ( e, settings, techNote, message ) {
      DatatableWarning.alert(techNote);
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/AdminReport/MasterShopByBrand.vue